import m from "../../geodata/es2015/congoDRLow";
window.am4geodata_congoDRLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/congoDRLow.js
// module id = null
// module chunks = 